<template>
    <span class="d-inline-block edit-detail">
        <b-btn @click="modalShow = !modalShow" variant="primary"  size="sm">
            {{ $t('button.Change') }}
        </b-btn>
        <b-modal
                ref="editPersonalInfo"
                size="lg"
                :no-close-on-backdrop="true"
                :title="$t('pages.ChangePersonalInfo')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <div class="alert alert-success" v-if="success">{{success}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="create"/>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >{{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="primary"
                        @click="submit"
                        :disabled="disabled"
                >{{$t('button.Save')}}
                </b-btn>
            </div>
        </b-modal>
    </span>
</template>

<script>
  import validation from '../../utils/preDefinedValidation';
  import { mapActions } from 'vuex';
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import { ERROR_MESSAGES } from '../../constants';

  export default {
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    props: ['lastName', 'phone', 'city', 'email', 'avatar', 'nick'],
    data() {
      return {
        modalShow: false,
        disabled: false,
        error: '',
        success: '',
        form: {},
        model: {
          avatar: this.avatar ? this.avatar : '',
          city: this.city ? this.city : '',
          phone: this.phone ? this.phone.toString() :'',
          lastName: this.lastName ? this.lastName :'',
          email: this.email ? this.email :'',
          nick: this.nick ? this.nick :''
        },
        fields: [
          {
            key: 'avatar',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Avatar'),
              class: 'col-4 m-auto'
            },
            required: false
          },
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Email'),
            },
            required: true,
            validation: {
              valid: validation.validEmail
            }
          },
          {
            key: 'city',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.City'),
              onBlur: function(e) {
                this.model.city = e.target.value.capitalize();
              }
            },
            required: true,
            validation: {
              valid: validation.validString
            }
          },
          {
            key: 'phone',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.PhoneNumber'),
            },
            required: true,
            validators: {
              valid: validation.validPhone
            }
          },
          {
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.LastName'),
              onBlur: function(e) {
                this.model.lastName = e.target.value.capitalize();
              }
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
              key: 'nick',
              type: 'input',
              templateOptions: {
                  label: this.$t('fields.Nick'),
                  onBlur: function(e) {
                      this.model.nick = e.target.value.capitalize();
                  }
              },
              required: false
          }
        ]
      };
    },
    methods: {
      ...mapActions(['editUserProfile', 'userInfo']),
      submit(e) {
        e.preventDefault();
        this.$refs.create.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;

            this.editUserProfile(this.model)
              .then(() => {
                // load updated user profile
                this.userInfo()
                  .then(() => {
                    this.success = this.$t('profile.editProfile.success');
                    setTimeout(() => {
                      this.disabled = false;
                      this.modalShow = false;
                      this.success = '';
                    }, 1000);
                  });
              })
              .catch(() => {
                this.disabled = false;
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>


<style>
</style>
